import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { WithStyles } from 'decorators/withStyles';
import React, { Component } from 'react';
import NoThemesSvg from './NoSearchSvg';

interface IProps {
  classes?: any;
}

@WithStyles(() => ({
  container: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column wrap'
  },
  title: {
    color: '#37474F',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    marginBottom: 10
  },
  subtitle: {
    color: '#546E7A',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '1rem',
    width: 440,
    textAlign: 'center',
    lineHeight: '150%'
  }
}))
export class NoSearchState extends Component<IProps, {}> {
  render() {
    const { classes } = this.props;

    return (
      <Grid container className={classes.container}>
        <NoThemesSvg />
        <Typography variant="h5" className={classes.title}>
          Nenhum resultado encontrado
        </Typography>
        <Typography variant="subtitle2" className={classes.subtitle}>
          Não encontramos nenhum resultado para sua busca, tente um novo nome.
        </Typography>
      </Grid>
    );
  }
}
